import { IDayBlockDTO, DayBlockDTO } from './day-block';
import { FileUpload } from './file';
import { GradeUnitDayDTO, IGradeUnitDayDTO } from './grade-unit/grade-unit-day';
import { BLOCK_TYPES } from '@utils/constants';
import { GradeLevel } from './grade-level';
import { INoteDTO } from './note';
import { PageContentDTO } from './page-content';
import { RetryDTO } from './retry';

export enum FileTypes {
  IMAGE = 'Image',
  VIDEO = 'Video',
  AUDIO = 'Audio',
  DOCUMENT = 'Document',
}

export interface IFile {
  fileName: string;
  location: string;
  signedUrl: string;
  fileType: FileTypes;
}

export interface IImageBlockDTO extends IDayBlockDTO {
  file: FileUpload;
}

export class ImageBlockDTO extends DayBlockDTO implements IImageBlockDTO {
  id: number = 0;
  position: number = 0;
  dayNumber: number = 0;
  blockType: BLOCK_TYPES = BLOCK_TYPES.ImageBlock;
  day = new GradeUnitDayDTO();
  file: FileUpload = null;

  constructor(configOverride?: Partial<IImageBlockDTO>) {
    super();
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IDocumentBlockDTO extends IDayBlockDTO {
  file: FileUpload;
  thumbnail: FileUpload;
  thumbnailId: string;
}

export class DocumentBlockDTO extends DayBlockDTO implements IDocumentBlockDTO {
  file: FileUpload;
  thumbnail: FileUpload;
  thumbnailId: string;
  constructor(configOverride?: Partial<IDocumentBlockDTO>) {
    super();
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
